var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-switch',{attrs:{"label":_vm.$t('medkitlogs.firstAidKitUsed'),"data-cy":"med"},model:{value:(_vm.value.med),callback:function ($$v) {_vm.$set(_vm.value, "med", $$v)},expression:"value.med"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }